// extracted by mini-css-extract-plugin
export default {"mainContainer":"Home_mainContainer__KBLww","paddedContent":"Home_paddedContent__oVnxJ","categoriesContainer":"Home_categoriesContainer__MPtby"};